import { Component, Input } from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';

const LOCAL_STORAGE_KEY = 'toggle-state';

function getToggleState(): { [key: string]: boolean } {
  const value = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (value !== null) {
    return JSON.parse(value);
  } else {
    return {};
  }
}

function setToggleState(key: string, value: boolean): void {
  const newState = {
    ...getToggleState(),
    [key]: value,
  };
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newState));
}

@Component({
  selector: 'toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent {
  constructor() {}

  @Input()
  icon: IconComponent.Name | null = null;

  @Input()
  header: string = '';

  @Input()
  defaultOpen: boolean = false;

  get open(): boolean {
    const state = getToggleState();
    if (this.stateKey in state) {
      return state[this.stateKey];
    } else {
      return this.defaultOpen;
    }
  }

  set open(value: boolean) {
    setToggleState(this.stateKey, value);
  }

  @Input()
  stateKey: string;
}
